import { createFeature, createReducer, on, createSelector } from '@ngrx/store';
import { Order } from '@us/web/shared/data-access';
import { OrdersActions } from './orders.actions';
import { cloneDeep } from 'lodash';
import { getObjectDifferences } from '@us/web/shared/utils';

export const ORDERS_FEATURE_KEY = 'orders';

export interface State {
    orders: Order[];
    loading: boolean;
}

export const initialState: State = {
    orders: [],
    loading: false
};

export const ordersFeature = createFeature({
    name: ORDERS_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(OrdersActions.loadOrders, (state): State => ({ ...state, loading: true })),
        on(OrdersActions.loadOrdersSuccess, (state, { orders }): State => ({ ...state, orders, loading: false })),
        on(OrdersActions.loadOrdersFailure, (state, { error }): State => ({ ...state, loading: false })),
        on(
            OrdersActions.loadOrder,
            OrdersActions.loadOrderPaymentStatus,
            (state): State => ({ ...state, loading: true })
        ),
        on(OrdersActions.loadOrderSuccess, (state, { order }): State => {
            const orders = cloneDeep(state.orders);
            const index = orders.findIndex(o => o.order_id === order.order_id);
            if (index === -1) {
                orders.unshift(order);
            } else {
                const prevOrder = cloneDeep(orders[index]);
                if (order.version_code < prevOrder.version_code) {
                    console.warn('Old order version', getObjectDifferences(prevOrder, order));
                } else {
                    orders[index] = order;
                }
            }

            return {
                orders,
                loading: false
            };
        }),
        on(OrdersActions.loadOrderFailed, (state, { error }): State => ({ ...state, loading: false }))
    )
});

export const { name, reducer, selectOrdersState, selectOrders, selectLoading } = ordersFeature;

export const selectOrder = (id: string) =>
    createSelector(selectOrders, orders => orders.find(order => order.order_id === id) || null);
